// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"159":"yeti","354":"wiki-tools","819":"data-table"}[chunkId] + "." + {"159":"069f0795","354":"3b4330dd","819":"7a2dd8d5"}[chunkId] + ".css";
};